export default __webpack_public_path__ + "static/media/pic_qr_wechat.72ff0820.png";